import React, {Fragment, useEffect, useState} from 'react';
import {Checkbox, Form, Grid, Input} from "semantic-ui-react";
import Info from "../../../components/Info";
import DatePicker from "../../../components/DatePicker/DatePicker";
import NumberInput from "../../../controls/numberInput";
import SectionForm from "./sectionForm";
import CalcByPlaces from "./calcByPlaces";
import DocParams from "./docParams";
import TotalVolumeAndWeight from "./totalVolumeAndWeight";
import {toast} from "react-toastify";
import InputTwoValues from "../../../components/InputTwoValues";
import {getDay} from "date-fns";
import {costFormat} from "../../../services/cost";

const InfoSection = ({isCreate = false, resetData, total, isDoc, form, changeForm, errors, companyData = {}, temperatureRegime = false, weekdays, valueDeclaredDisabled}) => {

    const [temperatureRegimeOn, setTemperatureRegimeOn] = useState(false);

    useEffect(() => {
        setTemperatureRegimeOn(temperatureRegime);
    }, [temperatureRegime]);

    const cargoDescriptionField = <Form.Field error={errors['cargoDescription']}>
        <label>Описание содержимого*</label>
        <Input
            maxLength={255}
            name='cargoDescription'
            value={form.cargoDescription || ''}
            onChange={(e, {name, value}) => changeForm(name, value)}
            placeholder={'НАПРИМЕР, ЦЕННЫЙ ГРУЗ'}
            disabled={!isCreate}
        />
    </Form.Field>

    return (
        <SectionForm
            label={'Информация об отправлении'}
            icon={<svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.4935 2.57194L6.97219 10.0066L1.2002 7.16661L15.4655 0.12261C15.7855 -0.0400563 16.1695 -0.0400563 16.5055 0.12261L21.4935 2.57194Z"
                    fill="#459EFF"/>
                <path
                    d="M30.7841 7.16659L16.0081 14.4866L10.4748 11.7599L9.6748 11.3533L24.2121 3.91992L25.0121 4.32526L30.7841 7.16659Z"
                    fill="#459EFF"/>
                <path
                    d="M14.824 16.5959L14.808 31.9999L0.656 24.6145C0.256 24.4039 0 23.9812 0 23.5265V9.27588L5.99733 12.2305V17.4252C5.99733 18.0905 6.54133 18.6425 7.19733 18.6425C7.85333 18.6425 8.39733 18.0905 8.39733 17.4252V13.4319L9.19733 13.8212L14.824 16.5959Z"
                    fill="#135CA9"/>
                <path d="M31.984 9.29199L17.224 16.58L17.208 31.984L32 24.26L31.984 9.29199Z"
                      fill="#135CA9"/>
            </svg>}
            actions={isCreate && <div className='total__change-btn' onClick={resetData}>
                <div className='total__change-btn_name total__change-btn_img'>Изменить данные и тип
                    отправления
                </div>
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <circle cx="14" cy="14" r="13.5" fill="#459EFF" stroke="#459EFF"/>
                    <g clipPath="url(#clip0_0_555)">
                        <path
                            d="M15.2792 10.5194L17.4151 12.6553L12.0084 18.062L9.87372 15.9261L15.2792 10.5194ZM19.0359 10.0043L18.0833 9.05173C17.7152 8.6836 17.1174 8.6836 16.748 9.05173L15.8356 9.96417L17.9715 12.1001L19.0359 11.0358C19.3214 10.7503 19.3214 10.2898 19.0359 10.0043ZM8.75594 18.9283C8.71707 19.1032 8.87502 19.26 9.04998 19.2174L11.4301 18.6403L9.2954 16.5044L8.75594 18.9283Z"
                            fill="white"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_0_555">
                            <rect width="10.5" height="10.5" fill="white" transform="translate(8.75 8.75)"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>}
            footer={total}
        >
            <Form className={!isCreate ? 'info-view' : ''}>
                {!isDoc && (!form.positions ? <TotalVolumeAndWeight
                    form={form}
                    changeParam={changeForm}
                    errors={errors}
                /> : <CalcByPlaces
                    positions={form.positions || [{}]}
                    changeParam={changeForm}
                    errors={errors}
                    isCreate={isCreate}
                    disabled={!isCreate}
                />)}

                {isDoc && <DocParams
                    disabled={!isCreate}
                    form={form}
                    changeParam={changeForm}
                    errors={errors}
                    field={cargoDescriptionField}
                />}

                {!isDoc && cargoDescriptionField}

                <div className='info-forms'>
                    <div className={`result-filter ${isCreate ? 'border-bottom' : ''} p-b-0`}>
                        {/*isCreate && <div className='input-with-checkbox'>
                            <Checkbox
                                checked={temperatureRegimeOn}
                                onChange={(e, {checked}) => {
                                    setTemperatureRegimeOn(checked);
                                    if (!checked) {
                                        changeForm('tempConditionLow', null);
                                        changeForm('tempConditionHigh', null);
                                    }
                                    !temperatureRegime && checked && toast.info("Ваше отправление будет обработано персональным менеджером");
                                }}
                            />
                            <Form.Field error={errors['tempConditionLow'] || errors['tempConditionHigh']}>
                                <label>
                                    Температурный режим, °С <Info name={'Температурный режим, °С'}
                                                                  text={'При заявке с температурным режимом просьба обращаться к Вашему менеджеру'}/>
                                </label>
                                <InputTwoValues
                                    disabled={!temperatureRegimeOn}
                                    onChange={(v1, v2) => {
                                        changeForm('tempConditionLow', v1);
                                        changeForm('tempConditionHigh', v2);
                                    }}
                                    value1={form.tempConditionLow}
                                    value2={form.tempConditionHigh}
                                />
                            </Form.Field>
                        </div>*/}

                        <div className={'date-fields'}>
                            <Form.Field>
                                <label>
                                    Забор груза*
                                </label>
                                <DatePicker
                                    excludeDates={(weekdays || []).map(w => new Date(w))}
                                    disabled={!isCreate || (form.selectedTariff && form.selectedTariff.isCurrentDayOnly)}
                                    minDate={new Date()}
                                    dateFormat='dd.MM.yyyy'
                                    placeholderText='дд.мм.гггг'
                                    value={form.departureDate ? new Date(form.departureDate) : null}
                                    onChange={(e, {value}) => changeForm('departureDate', value)}
                                />
                            </Form.Field>

                            <Form.Field>
                                <label>
                                    Дата доставки
                                </label>
                                <DatePicker
                                    onChange={()=>null}
                                    disabled
                                    dateFormat='dd.MM.yyyy'
                                    placeholderText='дд.мм.гггг'
                                    value={(form.selectedTariff && form.selectedTariff.minDeliveryTime) ? new Date(form.selectedTariff.minDeliveryTime) : null}
                                />
                            </Form.Field>
                        </div>
                    </div>
                    <div className='ui form'>
                        <Form.Field className='result-step__item checkbox-inputs-block'>
                            {!(companyData && companyData.isInsuranceRequired) && <Checkbox
                                checked={companyData && companyData.isInsuranceRequired ? companyData.isInsuranceRequired : form.isValueDeclared}
                                onChange={(e, {checked}) => changeForm('isValueDeclared', checked)}
                                disabled={form.isInsuranceRequired || !isCreate || valueDeclaredDisabled}
                                label={companyData && companyData.isInsuranceRequired ? 'Объявленная ценность груза' : 'Ваше отправление застраховано на'}
                            />}
                            {
                                companyData && companyData.isInsuranceRequired && <Info
                                    className={'m-t-0'}
                                    name={'Объявленная ценность груза'}
                                    text={'Согласно договору сервис несет ответственность за сохранность груза, укажите объявленную ценность груза'}
                                />
                            }
                            <Form.Field error={errors['declaredCargoValue']}>
                                <label>
                                Объявленная ценность груза
                                </label>
                                {
                                    (!form.isValueDeclared || !isCreate)
                                    ? <Input
                                            id="declaredCargoValue"
                                            value={costFormat(form.declaredCargoValue)}
                                            disabled
                                        />
                                    : <NumberInput
                                        id="declaredCargoValue"
                                        value={form.declaredCargoValue}
                                        decimals="2"
                                        min="1"
                                        onChange={value => changeForm("declaredCargoValue", value)}
                                    />
                                }
                            </Form.Field>
                            {
                                !(companyData && companyData.isInsuranceRequired) && <Fragment>
                                    {!isCreate && <div className='w-100'/>}
                                    <label>
                                        <div> Стоимость услуги страхования
                                            <Info
                                                className={'popup__info'}
                                                name={'Стоимость услуги страхования'}
                                                text={!isDoc ? "Стоимость страховки 0,2% от объявленной стоимости, не менее 30 р. При наступлении страхового случая возврат производится при предоставлении инвойса, счет-фактуры или иного документа, подтверждающего стоимость перевозимого груза. Страхование грузов до 3 000 000 рублей."
                                                        : "Стоимость страховки - 25 руб. Страхование документов до 3000 рублей."}/>
                                        </div>
                                    </label>
                                    <Form.Field>
                                        <label>
                                        Объявленная ценность груза
                                        </label>
                                        <Input
                                            id="declaredCargoValue"
                                            value={form.insuranceCost ? costFormat(form.insuranceCost) : ""}
                                            disabled
                                        />
                                    </Form.Field>
                                </Fragment>
                            }
                        </Form.Field>
                        {!isDoc && <Form.Field>
                            <Checkbox
                                checked={form.isNoDeclaredValueConfirmation}
                                onChange={(e, {checked}) => changeForm('isNoDeclaredValueConfirmation', checked)}
                                disabled={!isCreate}
                                label={'Нет документов, подтверждающих стоимость груза'}
                            />
                            <Info
                                className={'popup__info'}
                                name={'Нет документов, подтверждающих стоимость груза'}
                                text={'Инвойс - документ, подтверждающий стоимость груза. Без инвойса максимальная сумма страхования - 3000р.'}/>
                        </Form.Field>}

                        <Form.Field>
                            <Checkbox
                                checked={form.allStatusNotifications}
                                onChange={(e, { checked }) => changeForm('allStatusNotifications', checked)}
                                disabled={!isCreate}
                                label={'Хочу отслеживать отправление'}
                            />
                            <Info
                                className={'popup__info'}
                                name={'Хочу отслеживать отправление'}
                                text={'При выборе данной опции Вам на почту будут отправляться уведомления о изменении статуса посылки'} />
                        </Form.Field>
                    </div>
                </div>

                {isCreate && form.selectedTariff && form.selectedTariff.isRecipientCompanyRequired && <Grid>
                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <Form.Field error={errors['recipientInn']}>
                                <label>
                                    ИНН получателя*
                                    <Info
                                        name={'ИНН получателя'}
                                        text={'Это поле является обязательным по условиям ТК'}
                                    />
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    name='recipientInn'
                                    value={form.recipientInn || ''}
                                    onChange={(e, {name, value}) => changeForm(name, value)}
                                />
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>}
            </Form>
        </SectionForm>
    );
};

export default InfoSection;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/infoSection.jsx